<template>
  <footer class="border-t border-slate-800 bg-slate-900 py-8 text-slate-400">
    <div class="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
      <div class="text-sm">
        &copy; {{ new Date().getFullYear() }} CodeCopy. All rights reserved.
      </div>
      <div class="flex items-center gap-6 text-sm">
        <a href="#" class="hover:text-white transition-colors">Privacy Policy</a>
        <a href="#" class="hover:text-white transition-colors">Terms of Use</a>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppFooter',
});
</script>
